import * as React from 'react';
import { gql } from '@apollo/client';
import { NewWorkspaceModalController, NewWorkspaceModalControllerProps } from './NewWorkspaceModal.controller';
import {
  GetOrganizationDocument,
  useCreateWorkspaceMutation,
  useUpdateWorkspaceMutation
} from '../../../models/graphql';
import { useSelectedOrganization } from '../../../hooks/useSelectedOrganization';

export type NewWorkspaceModalApolloProps = Omit<
  NewWorkspaceModalControllerProps,
  'createWorkspace' | 'updateWorkspace'
> & {
  // ...
};

gql`
  mutation CreateWorkspace($organizationId: ID!, $input: WorkspaceInput!) {
    createWorkspace(organizationId: $organizationId, input: $input) {
      id
      name
      timezone
      users {
        id
        firstName
        email
        appRole
      }
      organization {
        id
      }
    }
  }

  mutation UpdateWorkspace($workspaceId: ID!, $input: WorkspaceInput!) {
    updateWorkspace(workspaceId: $workspaceId, input: $input) {
      id
      name
      timezone
      users {
        id
        firstName
        email
        appRole
      }
      organization {
        id
      }
    }
  }
`;

export const NewWorkspaceModalApollo = (props: NewWorkspaceModalApolloProps): JSX.Element => {
  const { selectedOrganization } = useSelectedOrganization();
  const [createWorkspace] = useCreateWorkspaceMutation({
    refetchQueries: [
      {
        query: GetOrganizationDocument,
        variables: { organizationId: selectedOrganization?.id }
      }
    ]
  });

  const [updateWorkspace] = useUpdateWorkspaceMutation({
    refetchQueries: [
      {
        query: GetOrganizationDocument,
        variables: { organizationId: selectedOrganization?.id }
      }
    ]
  });

  const controllerProps: NewWorkspaceModalControllerProps = {
    ...props,
    createWorkspace,
    updateWorkspace
  };

  return <NewWorkspaceModalController {...controllerProps} />;
};
